import React, { Component } from "react";
import "./SampleDL.scss";
import DLFront from "../../../assets/docSampleImages/DL FRONT.jpg";
import DLBACK from "../../../assets/docSampleImages/DL BACK.jpg";
import BottomPanel from "../../BottomPanel/BottomPanel";
export interface ISampleDLMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const SampleSDLMobileViewProps = (props: ISampleDLMobileViewProps) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view">
        <label className="mobile-view-text">Uploading Driving Licence</label>
        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Driving Licence in
              JPEG or PNG (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={DLFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                />
                <div className="badge">1</div>
              </div>

              <label className="Aadhar-Label">FRONT</label>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={DLBACK}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                />
                <div className="badge">2</div>
              </div>

              <label className="Aadhar-Label">BACK</label>
            </span>
          </span>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel
      customComponent={getMobileUIPopup}
      setShowSection={props?.setShowPopup}
    />
  );
};
export default SampleSDLMobileViewProps;
